import "./style.scss";
import { useState, useEffect } from "react";
import { useNavigate, useLocation } from 'react-router-dom';

function Prices() {
  const [prices, setPrices] = useState({});
  const [openCategory, setOpenCategory] = useState(null);
  const [openDoctor, setOpenDoctor] = useState(null);
  const [doctorNameToId, setDoctorNameToId] = useState({});

  const navigate = useNavigate();
  const location = useLocation();

  const serviceList = [
    "Belgyógyászat",
    "Bőrgyógyászat",
    "Dietetika",
    "Endokrinológia",
    "Foglalkozás-egészségügy",
    "Fül-orr-gégészet",
    "Gyermekorvos",
    "Kardiológia",
    "Kézsebészet",
    "Lézersebészet",
    "Neurológia",
    "Nőgyógyászat",
    "Ortopédia",
    "SYNLAB-Partner Mundimed",
    "Ultrahang",
    "Urológia",
  ];

  useEffect(() => {
    fetch("/ServicePrices.json")
      .then((response) => response.json())
      .then((data) => {
        setPrices(data);

        // Automatikus lenyitás query paraméter alapján
        const params = new URLSearchParams(location.search);
        const doctorQuery = params.get("doctor");

        if (doctorQuery) {
          for (const [categoryKey, items] of Object.entries(data)) {
            const match = items.find((item) => item.doctor === doctorQuery);
            if (match) {
              const categoryName = capitalizeFirstLetter(categoryKey);
              setOpenCategory(categoryName);
              setOpenDoctor(doctorQuery);

              let attempts = 0;
              const maxAttempts = 20;

              const scrollInterval = setInterval(() => {
                const el = document.getElementById(`doctor-${doctorQuery}`);
                if (el) {
                  el.scrollIntoView({ behavior: 'smooth', block: 'center' });
                  clearInterval(scrollInterval);
                }
                if (++attempts > maxAttempts) {
                  clearInterval(scrollInterval);
                }
              }, 100);
              break;
            }
          }
        }
      })
      .catch((error) =>
        console.error("Hiba történt az adatok betöltésekor:", error)
      );
  }, [location.search]);

  useEffect(() => {
    fetch('/DoctorsData.json')
      .then(res => res.json())
      .then(data => {
        const allDoctors = Object.values(data).flat();
        const nameToIdMap = {};
        allDoctors.forEach(doctor => {
          nameToIdMap[doctor.name] = doctor.id;
        });
        setDoctorNameToId(nameToIdMap);
      })
      .catch(err => console.error("Nem sikerült betölteni a DoctorsData.json fájlt:", err));
  }, []);

  const toggleCategory = (service) => {
    setOpenCategory(openCategory === service ? null : service);
    setOpenDoctor(null);
  };

  const toggleDoctor = (doctorName) => {
    setOpenDoctor(openDoctor === doctorName ? null : doctorName);
  };


  const capitalizeFirstLetter = (string) => {
    return string.charAt(0).toUpperCase() + string.slice(1);
  };
  

  return (
    <section className="price-screen">
      <div className="container">
        <h1 className="main-title">Áraink</h1>
        <ul className="service-list">
        
          {serviceList.map((service) => {
            const serviceKey = service.toLowerCase();
            const servicePrices = prices[serviceKey];

            // Szűrés az elérhető orvosokra (ha van adat)
            const uniqueDoctors =
              servicePrices &&
              [...new Set(servicePrices.map((item) => item.doctor))];

              if (service === "SYNLAB-Partner Mundimed") {
                return (
                  <li key={service} className="service-item">
                    <a
                      className="synlab-button"
                      href="https://mundimed.hu/vac"
                      target="_blank"
                    >
                      {service}
                    </a>
                  </li>
                );
              }

            return (
              <li key={service} className="service-item">
                <button
                  className="service-header"
                  onClick={() => toggleCategory(service)}
                >
                  {service}
                  <span>{openCategory === service ? "▲" : "▼"}</span>
                </button>

                {openCategory === service && (
                  <ul className="doctor-list">
                    {uniqueDoctors?.map((doctor, idx) => (
                      <li key={idx} className="doctor-item" id={`doctor-${doctor}`}>
                        <button
                          className="doctor-header"
                          onClick={() => toggleDoctor(doctor)}
                        >
                          {doctor}
                          <span>{openDoctor === doctor ? "▲" : "▼"}</span>
                        </button>

                        {openDoctor === doctor && (
                          <ul className="price-details">
                            {servicePrices
                              .filter((item) => item.doctor === doctor)
                              .map((price, idy) => (
                                <li
                                  key={idy}
                                  className="price-item"
                                >
                                  <p className="service-name">{price.name}</p>
                                  <p className="price">
                                    {price.price} {price.currency}
                                  </p>
                                </li>
                              ))}
                          </ul>
                        )}
                      </li>
                    ))}
                  </ul>
                )}
              </li>
            );
          })}
        </ul>
      </div>
    </section>
  );
}

export default Prices;
